@if (!isLoading && false) {
  <app-whats-new></app-whats-new>
}

@if (!isLoading) {
  <div class="live-map-container">

    <div #mapContent class="map__content">
      <app-map-panel
        [mapTitle]="'Live Map'"
      ></app-map-panel>
    </div>

    <div
      class="live__left__content"
      [ngClass]="{ collapse: (sidenavOpen$ | async) === false }"
    >
      @if (configuration && mapComponent?.mapLayersManager) {
        <div class="left__panel">
          <app-live-map-left-panel
            [configuration]="configuration"
            (activeItemChanged)="onActiveItemChanged($event)"
          >
          </app-live-map-left-panel>
        </div>
      }

      <div class="left__panel__round-corners">
        <div class="left__panel__round-corners__box">
        </div>
      </div>

      <div class="left__map__overlay"
      >
        @if (mapComponent?.mapLayersManager) {
          <div class="overlay-top-content">
            <app-status-layer-switcher
              [mapLayersManager]="mapComponent.mapLayersManager"
            >
            </app-status-layer-switcher>
          </div>

          <div class="overlay-bottom-left-content">
            <app-map-layer-switcher
              [mapLayersManager]="mapComponent.mapLayersManager"
            >
            </app-map-layer-switcher>
          </div>
        }
      </div>
    </div>

    <div class="live__right__content"
    >
      @if (showMapOverlay !== MapOverlayType.NONE) {
        <div class="right__map__overlay"
             [ngClass]="{ collapse: (sidenavOpen$ | async) === false,
                      rightDrawer: !!activeDrawer,
                      fullMapOverlay: showMapOverlay === MapOverlayType.FULL,
                      narrowMapOverlay: showMapOverlay === MapOverlayType.NARROW,
                      }"
        >
          <router-outlet></router-outlet>
        </div>
      }

      <div class="right__panel__round-corners">
        <div class="right__panel__round-corners__box">
        </div>
      </div>

      <div class="right__panel"
      >
        <div class="right__panel__quick__actions">
          <app-right-panel-button
            [drawerType]="DrawerType.ROUTE"
          >
          </app-right-panel-button>
          <app-right-panel-button
            [drawerType]="DrawerType.MESSAGES"
          >
          </app-right-panel-button>
          <app-right-panel-button
            [drawerType]="DrawerType.OBSERVATION"
          >
          </app-right-panel-button>
          <!--<app-right-panel-button
                  *ngIf="hasFeatureFlag(FeatureFlagEnum.DashCam)"
                  [drawerType]="DrawerType.LIVE_VIDEO"
          >
          </app-right-panel-button>-->
          <app-right-panel-button
            [drawerType]="DrawerType.ALERTS"
            [badgeNumber]="eventsNotReadCount"
          >
          </app-right-panel-button>
          <app-right-panel-button
            [drawerType]="DrawerType.QUICK_INSIGHTS"
          >
          </app-right-panel-button>
        </div>
        <div class="right__panel__bottom__actions">
          <button mat-icon-button
                  [routerLink]="['/' + RootRoute.MAIN, MainRoute.ABOUT]"
                  matTooltip="About"
                  matTooltipPosition="left">
            <mat-icon>info</mat-icon>
          </button>
        </div>
      </div>
    </div>

    <div class="live__bottom__panel">
    </div>
  </div>
}

@if (isLoading) {
  <div class="loader-container">
    <app-live-map-loader
      [message]="loadingDataName"
      [loadErrorMessage]="loadError"
    >
    </app-live-map-loader>
  </div>
}
